import React from 'react';
import { credibility, event } from '../data/masterclass';
import { GalleryCarousel } from './GalleryCarousel';
export function Credibility() {
  return <section aria-labelledby="credibility-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-27" data-mp="2kmpu7k2wppcp">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-28" data-mp="2un07f4oxywrv">
        <div className="grid grid-cols-1 items-start gap-10 sm:grid-cols-[minmax(220px,0.75fr)_1.25fr] sm:gap-12" data-id="element-29" data-mp="2ulp5zbiyy13x">
          <img src={event.portraitUrl} alt="Curtis and Spring Eatmon IV" className="w-full max-w-sm object-cover" data-id="element-30" data-mp="38g806zordyb5" />

          <div data-id="element-31" data-mp="3ib9qhyurt6fb">
            <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-32" data-mp="3ibt79c8oporr">
              Curtis &amp; Spring Eatmon IV
            </p>
            <h2 id="credibility-heading" className="mt-4 font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-33" data-mp="1ny1o9m4gtsjn">
              We didn’t learn this from the sidelines.{' '}
              <span className="text-gold" data-id="element-34" data-mp="31hi7u4hwfgyz">We’ve had to live it.</span>
            </h2>
            <p className="mt-8 max-w-[68ch] text-lg leading-[1.8] text-white/70" data-id="element-35" data-mp="35ibw4yz96xse">
              {credibility.body}
            </p>
          </div>
        </div>

        <GalleryCarousel data-id="element-36" data-mp="3f725ivwmho1f" />

        <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line sm:grid-cols-2 lg:grid-cols-3" data-id="element-37" data-mp="3f8dkzszfkk8d">
          {credibility.proof.map(block => <div key={block.label} className="bg-ink p-7" data-id="element-38" data-mp="3p502c7sjst5n">
              <dt className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-39" data-mp="3p7maa8jcpaoe">
                {block.label}
              </dt>
              <dd className="mt-3 leading-relaxed text-white/70" data-id="element-40" data-mp="21br670nf38v">{block.body}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}